import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import Router from 'next/router';
import { connect } from 'react-redux';

import Colors from '~/utils/colors';
import { cities, cityPageWhiteList } from '~/utils/filter/home-search-config';
import { actions as filterActions } from '~/redux/reducers/filter';
import { isAustralianSite } from '~/utils/region-site-config';
import FilterDropdown from './FilterDropdown';

const australianExcludedList = ['Near Bangkok', 'Near Chiang Mai', '+44 more cities'];

const cityExcludedList = ['Central Thailand', 'Eastern Thailand', 'Northeastern Thailand', 'Northern Thailand', 'Southern Thailand'];

const optionCities = cities
  .filter(c => c.children && c.children.length > 0)
  .filter(c => (isAustralianSite() ? !australianExcludedList.includes(c.label) : true))
  .map(c => ({ group: c.label, items: [...c.children] }));

// const optionDestinations = Object.keys(destinations).map(key => {
//   const optionItem = destinations[key]
//     .map(option => ({
//       value: JSON.stringify(option), label: option.label
//     }))
//     .filter(option => {
//       if (isAustralianSite()) {
//         return !australianExcludedList.includes(option.label);
//       }
//       return true;
//     });

//   return {
//     group: key,
//     items: optionItem
//   };
// });

const NavbarFilter = styled.div`
  z-index: 999;
  position: fixed;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 88px;
  background: ${Colors.blueGray};
  transform: translateY(88px);
  transition: transform 0.2s ease-in;
  ${props => props.slideIn && `
    transform: translateY(0);
    transition: transform 0.3s ease-out;
  `}
`;

const enhance = connect(
  state => ({
    activities: state.filter.activities,
  }),
  {
    ...filterActions,
  }
);
const FilterMenu = (props) => {
  const { url, activities, isShowFilterMenuBottom } = props;
  const [isHideNavber, setIsHideNavber] = useState(false);
  const coverDom = useRef(null);

  const onChangeFilterInfo = (data) => props.setFilterInfo({ ...props.filterInfo, ...data });

  const getActivityByCity = async (city) => {
    await props.getActivityByCity(city);
  };

  const setQueryString = async (data) => {
    const { query, pathname, fullPath } = data;
    await Router
      .push(
        {
          pathname,
          query,
        },
        fullPath
      );
    if (typeof window !== 'undefined' && window && window.scrollTo) {
      window.scrollTo(0, 0);
    }
  };

  const { city } = props.filterInfo;
  const activity = props.filterInfo.activity || props.url.query.activity;

  const onChangeFilter = (value, type) => {
    const data = {};
    if (type === 'city') {
      data.city = value;
      if ([
        'Phnom Penh',
        'Siem Reap',
        'Battambang',
        'Kampot'
      ].includes(value)) {
        data.activity = false;
      }
    }
    if (type === 'activity') {
      data.activity = value || 'popular';
    }
    onChangeFilterInfo(data);
  };

  const onClickFilter = () => {
    const isGoToCityPage = (city && !city.includes('Near') && !cityExcludedList.includes(city)) || cityPageWhiteList.includes(city);

    let pathname;
    let fullPath;
    const query = {};
    if (city === 'Other') {
      pathname = '/search';
      query.city = 'Other';
      query.type = 'local-experiences';
      fullPath = '/other-cities';
    } else if (isGoToCityPage) {
      pathname = '/city';
      query.city = city;
      fullPath = `/to/${city}${activity ? `?activity=${activity}` : ''}`;
      if (activity) query.activity = activity;
      getActivityByCity(city);
    } else {
      pathname = '/search/activity';
      fullPath = `/activity?activity=${activity}${city ? `&city=${city}` : ''}`;
      if (city) query.city = city;
      query.activity = activity;
    }

    const fromHome = !props.url;
    const isBottom = props.isShowFilterMenuBottom;
    let location = '';
    if (fromHome) location = 'Home Filter Menu';
    else if (isBottom) location = 'Bottom Filter Menu';
    else location = 'Banner Filter Menu';
    props.logFilterActivity(location, city || '', activity || '');
    return setQueryString({ query, pathname, fullPath });
  };

  useEffect(() => {
    if (props.noFilter) return;
    const { query, pathname } = props.url;
    const data = {};
    if (
      [
        'Phnom Penh',
        'Siem Reap',
        'Battambang',
        'Kampot'
      ].includes(city)
    ) {
      data.activity = false;
    }

    data.city = (query && query.city) || '';
    data.activity = (query && query.activity) || '';
    if (pathname === '/city') getActivityByCity(data.city);
    onChangeFilterInfo(data);

    let observer = {};
    if (isShowFilterMenuBottom) {
      observer = new IntersectionObserver(
        ([entry]) => {
          const { intersectionRatio, isIntersecting } = entry;
          if (!isIntersecting) {
            setIsHideNavber(false);
          } else if (intersectionRatio === 1) {
            setIsHideNavber(true);
          } else {
            setIsHideNavber(false);
          }
        }, {
          root: null,
          rootMargin: '0px',
          threshold: [0.4, 1.0]
        }
      );
      if (coverDom.current) {
        observer.observe(coverDom.current);
      }
    }
  }, [props.url]);

  return (
    <div>
      {!isShowFilterMenuBottom && (
        <FilterDropdown
          optionDestinations={optionCities}
          optionsActivity={activities}
          onClickFilter={onClickFilter}
          onChangeFilter={onChangeFilter}
          city={city}
          activity={activity}
          isShowByPage={url || { pathname: '/' }}
        />
      )}
      {isShowFilterMenuBottom && (
        <div ref={coverDom}>
          <NavbarFilter slideIn={!isHideNavber}>
            <FilterDropdown
              optionsActivity={activities}
              onChangeFilter={onChangeFilter}
              onClickFilter={onClickFilter}
              activity={activity}
              isShowByPage={url || { pathname: '/' }}
              navbar
            />
          </NavbarFilter>
        </div>
      )}
    </div>
  );
};

export default enhance(FilterMenu);
